import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  LISTA_TROCA_FOTO,
  APROVA_TROCA_FOTO,
  REPROVA_TROCA_FOTO,
} from 'constants/ActionTypes';
import requisicaoApiCarteirinha from 'util/ApiCarteirinha';
import {
  listaTrocaFotoSucesso,
  listaTrocaFotoErro,
  aprovaTrocaFotoSucesso,
  reprovaTrocaFotoSucesso,
  trocaFotoErro,
} from 'actions/TrocaFoto';

/*#################################################################################################################*/
/* --------------------------------------------- Requests do tipo GET ---------------------------------------------*/

const getTrocasFoto = async (pagina, tamanhoPagina, status) =>
  await requisicaoApiCarteirinha
    .get(`/v1/alteracao-foto?status=${status}&pagina=${pagina}&tamanhoPagina=${tamanhoPagina}`)
    .then(r => r)
    .catch(e => e);

/*#################################################################################################################*/
/* ------------------------------------- Requests do tipo PATCH ----------------------------------------------------*/

const patchAprovar = async (id) =>
  await requisicaoApiCarteirinha
    .patch(`/v1/alteracao-foto/${id}/aprovar`)
    .then(r => r)
    .catch(e => e);

const patchReprovar = async (id, motivo) =>
  await requisicaoApiCarteirinha
    .patch(`/v1/alteracao-foto/${id}/reprovar`, { motivo })
    .then(r => r)
    .catch(e => e);

/*#################################################################################################################*/
/* ----------------------------------------------- Sagas ----------------------------------------------------------*/

function* listarSaga({ payload }) {
  try {
    const { pagina, tamanhoPagina, status } = payload;
    const result = yield call(getTrocasFoto, pagina, tamanhoPagina, status);
    if (result.response && result.response.status >= 400) {
      yield put(listaTrocaFotoErro('Erro ao carregar solicitações de troca de foto.'));
    } else {
      yield put(listaTrocaFotoSucesso(result.data));
    }
  } catch (error) {
    yield put(listaTrocaFotoErro('Erro ao carregar solicitações de troca de foto.'));
  }
}

function* aprovarSaga({ payload }) {
  try {
    const result = yield call(patchAprovar, payload.id);
    if (result.response && result.response.status >= 400) {
      yield put(trocaFotoErro('Erro ao aprovar troca de foto.'));
    } else {
      yield put(aprovaTrocaFotoSucesso());
    }
  } catch (error) {
    yield put(trocaFotoErro('Erro ao aprovar troca de foto.'));
  }
}

function* reprovarSaga({ payload }) {
  try {
    const result = yield call(patchReprovar, payload.id, payload.motivo);
    if (result.response && result.response.status >= 400) {
      yield put(trocaFotoErro('Erro ao reprovar troca de foto.'));
    } else {
      yield put(reprovaTrocaFotoSucesso());
    }
  } catch (error) {
    yield put(trocaFotoErro('Erro ao reprovar troca de foto.'));
  }
}

export function* watchListar() {
  yield takeEvery(LISTA_TROCA_FOTO, listarSaga);
}

export function* watchAprovar() {
  yield takeEvery(APROVA_TROCA_FOTO, aprovarSaga);
}

export function* watchReprovar() {
  yield takeEvery(REPROVA_TROCA_FOTO, reprovarSaga);
}

export default function* rootSaga() {
  yield all([
    fork(watchListar),
    fork(watchAprovar),
    fork(watchReprovar),
  ]);
}
